<script>
export default {
  inheritAttrs: false,
  props: {
    active: {
      type: Boolean,
    },
  },
}
</script>

<template>
  <div
    :class="{ [$style.selector]: true, [$style.active]: active }"
    v-bind="$attrs"
    class="d-inline-block"
    data-base-selector
    v-on="$listeners">
    <p class="button-text">
      <slot />
    </p>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.selector {
  padding: 8px 16px;
  cursor: pointer;
  user-select: none;
  border: 1px solid $light-gray;
  border-radius: 8px;

  p {
    color: $light-gray;
    white-space: nowrap;
    @media (max-width: $lg-breakpoint) {
      line-height: 16px;
    }
  }

  &.active {
    color: $primary-blue;
    border: 1px solid $primary-blue;

    p {
      color: $primary-blue;
      white-space: nowrap;
    }
  }
}
</style>
